import styled from 'styled-components';
import { mediaHelper } from "../../utils/src";
import Colors from 'constants/Colors';


export const Container = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
`;

export const CardHeader = styled.div`
  display: flex;
  color:  black;
  align-items: center;
  padding: 5px;
  font-size: 14px;
  gap: 10px;
  
  ${mediaHelper.sm`
    font-size: 18px;
  `}
`;

export const IconsContainer = styled.div`
  display: flex;
  align-items: center;

  .icon-arrowup {
    width: 20px;
    height: 20px;
    min-width: 20px;
    transition: transform ease-in-out 200ms;
    margin-left: 8px;
    cursor: pointer;

    &:before{
      background-size: 100%;
      width: 80%;
      height: 80%;
      margin: 10%;
    }
    
    &.closed {
      transform: rotate(180deg);
    }
  }

  .icon-add {
    cursor: pointer;
  }
`;

export const CardContent = styled.div`
  background-color: #FFF;
  color: #000;
  
  flex-grow: 1;
  border-radius: 0px 0px 10px 10px;
  overflow: hidden;
  max-height: 0px;
  transition: all ease-in-out 500ms;
  
  ${mediaHelper.sm`
    border-radius: 0px 0px 15px 15px;
  `}
  
  ${mediaHelper.md`
    border-radius: 0px 0px 20px 20px;
  `}
  
  &.expanding {
    max-height: 2500px;
  }
  
  &.collapsing {
    max-height: 0;
  }
  
  &.expanded {
    max-height: unset;
    overflow: initial;
  }

  &.before-collapsing { 
    max-height: 2500px;
  }
`;

export const Expandable = styled.div`
  padding: 5px;
  
  ${mediaHelper.sm`
    padding: 10px;
  `}
`;

export const UpdateButton = styled.button`
  padding-left: 16px;
  padding-right: 16px;
  height: 40px;
  background: ${Colors.PINK};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
`;


export const CancelButton = styled.button`
  padding-left: 16px;
  padding-right: 16px;
  height: 40px;
  background: ${Colors.PURPLE};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
  margin-right: 8px;
`;

export const ContentTextArea = styled.div`
  width: 100%;  
  margin-top: 0px;
  margin-bottom: 8px;

`;
export const ButtonContent = styled.div`
  display: flex;
  flex-direction: auto;
  background-color: FFF;
  justify-content: space-evenly;
`;